<template>
  <div class="backnumberTab-container">
    <ul class="backnumberTab">
      <li v-for="category in categories" :key="category.value">
        <button
          type="button"
          :class="[
            'backnumberTab_button',
            { '-current': state.selectedCategory === category.value }
          ]"
          :data-category="category.value"
          @click="setCategory(category.value)"
        >
          {{ category.label }}
        </button>
      </li>
    </ul>
  </div>
  <ul class="backnumberList">
    <li v-for="item in backnumbers" :key="item.id">
      <router-link
        :to="`/magazines/exam/master/detail/${item.id}`"
        class="backnumberList_item"
      >
        <div class="backnumberList_body">
          <p v-html="item.question" />
          <p
            v-for="section in item.sections"
            :key="section"
            class="backnumberList_category"
          >
            {{ section }}
          </p>
          <p class="backnumberList_date">{{ item.date }}</p>
        </div>
        <!-- <div class="backnumberList_icon" :data-answer="item.answer">
          <p>{{ answerIconText[item.answer] }}</p>
        </div> -->
      </router-link>
    </li>
  </ul>
</template>

<script lang="ts">
import { reactive, computed, watch, defineComponent } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useTest } from '@/provider/test'

const answerIconText = {
  correct: '正解',
  incorrect: '不正解',
  no: '未回答'
}
const categories = [
  { label: '必修', value: '1' },
  { label: '一般', value: '2' },
  { label: '臨床', value: '3' }
]
export default defineComponent({
  name: 'ExamMasterList',
  props: {
    module: {
      type: Boolean,
      default: false
    },
    ignoreId: {
      type: Number,
      default: null
    },
    value: {
      type: String,
      default: '1'
    }
  },
  emits: ['input'],
  setup(props: any, context: any) {
    const route = useRoute()
    const page = computed(() => Number(route.query.page) || 1)
    const categoryId: any = route.params.categoryId
    const state = reactive({
      selectedCategory: categoryId || '1'
    })
    const { state: testState, getTests } = useTest()
    const limit = props.module ? 4 : 10
    const getBacknumbers = () => {
      getTests({
        limit,
        category: Number(state.selectedCategory),
        page: page.value
      })
    }
    const backnumbers = computed(() => {
      return props.module
        ? testState.tests
            .filter((d: any) => d.id !== props.ignoreId)
            .slice(0, 3)
        : testState.tests
    })

    const router = useRouter()
    watch(
      () => state.selectedCategory,
      () => {
        if (categoryId) {
          if (page.value === 1) getBacknumbers()
          router.push(`/magazines/exam/master/list/${state.selectedCategory}`)
        } else {
          getBacknumbers()
          context.emit('input', state.selectedCategory)
        }
      }
    )
    watch(() => page.value, getBacknumbers, { immediate: true })
    const setCategory = (category: string) => {
      state.selectedCategory = category
    }
    return {
      setCategory,
      state,
      answerIconText,
      categories,
      backnumbers
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.backnumberTab-container {
  margin: 16px -16px 0;
  border-bottom: 1px solid var.$color-border-gray;
}

.backnumberTab {
  @include mixins.media() {
    margin: 0 16px;
  }
  display: flex;
  > li {
    flex-grow: 1;
    flex-basis: 100%;
  }
}

.backnumberTab_button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 48px;
  font-weight: 500;
  font-size: 1.4rem;
  letter-spacing: 0.03em;

  &.-current {
    background-color: #666;
    color: #fff;
  }

  &[data-category='1'].-current {
    background-color: #f64545;
  }

  &[data-category='2'].-current {
    background-color: #3069ea;
  }

  &[data-category='3'].-current {
    background-color: #4cd348;
  }
}

.backnumberList {
  > li {
    border-bottom: 1px solid var.$color-border-gray;
  }
}

.backnumberList_item {
  display: flex;
  align-items: center;
  padding-top: 20px;
  padding-bottom: 20px;
  font-weight: 500;
  font-size: 1.4rem;
  letter-spacing: 0.03em;
  line-height: 1.5;
}

.backnumberList_body {
  flex-grow: 1;

  > p:first-child {
    margin-bottom: 4px;
  }
  > p:not(:first-child) {
    margin-right: 6px;
  }
}

.backnumberList_category {
  display: inline-block;
  padding: 4px 5px;
  font-size: 1rem;
  background-color: #fffccb;
}

.backnumberList_date {
  display: inline-block;
  font-size: 1.2rem;
}

.backnumberList_icon {
  // display: flex;
  display: none;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  flex-basis: 60px;
  height: 60px;
  margin-left: 18px;
  background-color: #f5f5f5;
  font-weight: bold;
  color: #a7a7a7;

  &[data-answer='correct'] {
    background-color: #e7f8f6;
    color: var.$color-main-text;
  }

  &[data-answer='incorrect'] {
    background-color: #e7f8f6;
    color: var.$color-main-text;
  }
}
</style>
